/** Application-wide constants (convention section 34). */

export const DEFAULT_PAGE_SIZE = 25;

export const DATE_FORMAT = "yyyy-MM-dd";

/** Route paths — single source of truth for typed navigation. */
export const ROUTES = {
  dashboard: "/",
  basicInformation: {
    hd: "/basic-information/hd",
  },
  oee: "/oee",
  paperUsage: "/paper-usage",
  printOverview: "/print-overview",
  runningStatus: "/running-status",
} as const;

/** Supported locales for formatting and UI translations (see `shared/i18n`). */
export const SUPPORTED_LOCALES = ["en-US", "ja-JP", "fr-FR"] as const;
export const DEFAULT_LOCALE: (typeof SUPPORTED_LOCALES)[number] = "en-US";
